<script lang="ts">
	import { is_set_array, setSearchParam, sortByName } from '$lib/js/helpers'
	import { orderFilterProducts, type ProductsEndpoint } from '$lib/js/products'
	import type { BaseProduct, Category, FullProduct, ProductQueryOptions } from '$lib/js/elasticsearch/types'
	import { onMount } from 'svelte'
	import { storeActiveFilters, storeSearchFilters } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { page } from '$app/state'
	import { getCheckedCatsIDs } from '$lib/js/search'
	import { getContextScope } from '$lib/js/helpers/i18n'

	interface Props {
		options: ProductQueryOptions;
		products?: (BaseProduct | FullProduct)[];
		type?: string; // '' | search
		endpoint: ProductsEndpoint;
	}

	let {
		options = $bindable(),
		products = $bindable([]),
		type = '',
		endpoint
	}: Props = $props();

	/* Get subcategories for filtering */
	let filteringCats: Category[] | undefined = $state(undefined)
	const scope = getContextScope()

	/* Category filters */
	async function orderFilteredProducts() {
		options.start = 0
		options.cat_ids = filteringCats ? getCheckedCatsIDs(filteringCats) : []
		$storeActiveFilters.subcats = filteringCats ? filteringCats.filter((cat) => cat.checked == true) : []
		products = await orderFilterProducts(options, endpoint, { scope: scope })
		updateUrl()

		options.start = 50
		document.getElementById('top-page')?.scrollIntoView({ behavior: 'smooth' })
	}

	function updateUrl() {
		if (type !== 'search') {
			const selectedCatsSlugs = $storeActiveFilters?.subcats?.map((cat) => cat.url_path.split('/')[cat.url_path.split('/').length - 1]).join(',')
			setSearchParam('cats', selectedCatsSlugs)
		}
	}

	filteringCats = (type === 'search' ? $storeSearchFilters?.subcats : page.data.subcats) || []

	onMount(() => {
		(async () => {
			// Reset all checked states to false on mount
			if (filteringCats) {
				filteringCats = filteringCats.map((cat: Category) => ({ ...cat, checked: false }))
			}

			let cat_slugs_list = page.url.searchParams.get('cats')?.split(',') ?? []

			if (cat_slugs_list && type !== 'search') {
				for (let index = 0; index < cat_slugs_list.length; index++) {
					const slug = cat_slugs_list[index]
					const id = filteringCats ? filteringCats.find((cat: Category) => cat.url_path.split('/')[cat.url_path.split('/').length - 1] === slug)?.id : undefined
					if (id) {
						filteringCats = filteringCats?.map((cat) => {
							return (cat.id === id) ? { ...cat, checked: true } : cat
						})
					}
				}

				$storeActiveFilters.subcats = filteringCats ? filteringCats.filter((cat) => cat.checked == true) : []
			}
		})()
	})
</script>


{#if filteringCats && is_set_array(filteringCats)}
	<div class="subcategory-filters">
		<div class="subcategory-filters__cats">
			<ul class="subcategory-filters__list">
				{#each sortByName(filteringCats) as cat}
					<li class:checked={cat.checked === true}>
						<input
							type="checkbox"
							id={cat.name}
							bind:checked={cat.checked}
							onchange={() => {
								orderFilteredProducts()
							}}
						/>
						<label class="brand-filters__brand" for={cat.name}>{cat.name}</label>
					</li>
				{/each}
			</ul>
		</div>
	</div>
{:else if filteringCats === undefined}
	<p class="loading">{$t`Loading subcategories...`}</p>
{:else}
	<p class="no-results">{$t`No catergories found`}</p>
{/if}


<style lang="scss">
	.no-results {
		color: var(--grey--b);
	}
	.subcategory-filters {
		&__list {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			background-color: var(--grey);
			border-radius: 5px;
			max-height: 130px;
			padding: 7px;
			overflow-y: auto;

			li {
				display: flex;
				align-items: flex-start;
				column-gap: 2px;
				margin-top: 4px;

				&:hover {
					color: var(--main);
				}

				&.checked {
					order: -1;
				}

				input {
					margin-top: 2px;
				}

				label {
					flex-grow: 1;
					line-height: 1.2;
				}
			}
		}
	}
</style>
